import styled from 'styled-components';
import React from 'react';
import { RewindButton } from '../buttons/RewindButton';
import { t } from 'ttag';
import { useGlobalMediaStore } from '~/ui/video-player/GlobalMediaProvider';

const Button = styled(RewindButton)`
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 101 !important;

  @media ((max-width: 580px) and (max-height: 300px)) {
    bottom: 5px;
    left: 10px;
  }
`;

export const TenSecsBack = () => {
  const globalMedia = useGlobalMediaStore();
  const globalPlayer = globalMedia?.player;

  if (!globalPlayer) return null;

  return (
    <Button
      onClick={() => {
        if (globalPlayer) {
          try {
            const newTime = globalPlayer.currentTime() - 10;
            globalPlayer.currentTime(newTime > 0 ? newTime : 0);
          } catch (error) {
            // Silently ignore player operation errors
          }
        }
      }}
    >
      10
      <span className="hidden">{t`seconds`}</span>
    </Button>
  );
};
